import(/* webpackMode: "eager", webpackExports: ["ExamResourceLayout"] */ "/vercel/path1/components/exam-resource-layout.tsx");
